// Icons Plugin
// These re-exports are not currently used, as Webpack 4 has
// issues with tree shaking re-exports of re-exports
// `/src/index.js` does a single level re-export `* from './icons/icons/icons'`
// Export all icons
export * from './icons'; // Export helper component

export { BIcon } from './icon'; // Export stacking component

export { BIconstack } from './iconstack'; // Plugin (an iconNames for docs)

export { IconsPlugin, BootstrapVueIcons, iconNames } from './plugin';


//////////////////
// WEBPACK FOOTER
// ./~/bootstrap-vue/esm/icons/index.js
// module id = ttPp
// module chunks = 86